import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	fileVsRegulatorColumn,
	licenseColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';

/**
 * No Verified License — active buyers holding licenses, none of which is verified against an in-force regulator record and none with a 90%+ suggestion. Same client-level predicate as the dashboard card.
 */
export const noVerifiedLicenseList: ListBuilderList = {
	id: 'compliance-no-verified-license',
	cacheTTL: 300000,
	// Tab label, deliberately short (Chris, 2026-09-20) so more tabs show in
	// the Needs Attention strip; the rest sit under More, which is accepted
	// (Chris, 2026-09-27). The full name is above and on the dashboard card.
	name: 'Unverified',
	type: 'default',
	active: true,
	sortOrder: 9,
	filterRules: {
		...hideOtherCardFilters(['licenseClientCoverage']),
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseClientCoverage: {
			defaultValue: [{ id: 'no_active_license', label: 'No Verified License' }],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		fileVsRegulatorColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
